import { render, staticRenderFns } from "./DeskEventEditor.vue?vue&type=template&id=663be45e&scoped=true&"
import script from "./DeskEventEditor.vue?vue&type=script&lang=js&"
export * from "./DeskEventEditor.vue?vue&type=script&lang=js&"
import style0 from "./DeskEventEditor.vue?vue&type=style&index=0&id=663be45e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663be45e",
  null
  
)

export default component.exports